<div class="progress" *ngIf="!pulseOnly">
  <div
    class="progress-bar"
    role="progressbar"
    [attr.aria-valuenow]="percent"
    aria-valuemin="0"
    aria-valuemax="100"
    #progressBar
  >
    <span class="sr-only">{{ percent }}% Complete</span>
  </div>
</div>

<span class="loading-beacon" *ngIf="!simple">
  <span class="pulse one"></span>
  <span class="pulse two"></span>
  <span class="pulse three"></span>
  <span class="spinner"></span>
</span>

<span class="status" *ngIf="!simple && !pulseOnly">
  Running <mode-counter [createdAt]="createdAt"></mode-counter>
</span>
